<script setup lang="ts">
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import { useGameStore } from '@/stores/gameStore.ts'
import { usePlanetStore } from '@/stores/planetStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'

const playerFlagsStore = usePlayerFlagsStore()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_settle_planet')
}

const isOnMap = computed(() => {
  return route.path.startsWith('/map')
})

const goToMap = () => {
  router.push('/map')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/colonizing.webm"
  >
    <template #text>
      <p class="pb-2">
        Ok, we have 2 colonizer ships we can command.
      </p>
      <p class="pb-2">
        The standard colonizers aren't very fast, so lets send them to the planets in our own solar system.
      </p>
      <p class="pb-2">
        The map interface will help you to figure out what planets are best for you and which ones already have a settler inbound.
      </p>
    </template>

    <template #alerts>
      <Alert type="info">
        <div class="ml-3">
          <ul class="list-decimal">
            <li>Find your homeworld on the map and click on it.</li>
            <li>In the popup, Click on your name in the ship list on the right.</li>
            <li>Find your ship named "Colonizer" and double click on its name.</li>
            <li>In the action bar select the "settle" <GenericIcon type="cmd_settle"/> command.</li>
            <li>Find a planet on your solar system and click on it.</li>
            <li>Now select "Set" and our scout will automatically fly to the selected planet and settle it.</li>
          </ul>
        </div>
      </Alert>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnMap" @click="goToMap" class="mr-2">
        Goto Map
      </ActionButton>
      <ActionButton @click="handleNextStep">
        Settlers are on their way!
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>